import { Box, Grid, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ContainerMaxWidth } from './organisms/layouts/Layout';
import { DesktopPaddingLarger, MobilePadding } from 'pages';
import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';
const StyledLink = styled(Link)`
  background-color: #3547c5;

  :hover {
    background-color: #4759cb;
  }
`;
const productItems = [{
  name: 'EV Savings Badge',
  image: '/assets/images/new-badge-2.png',
  block: <>
        <Typography sx={{
      fontWeight: 600,
      fontSize: 20,
      mt: '2rem'
    }}>
          Reveal <span style={{
        color: '#3547C5'
      }}>undiscovered</span> EV savings to your customers
        </Typography>

        <Typography sx={{
      mt: '24px',
      mb: '48px',
      color: '#484E67'
    }}>
          Our EV Savings Badge personalizes federal tax incentives, state rebates and fuel cost savings for each VIN in
          your electric inventory. Show customers undiscovered savings, and capture more leads for your sales team via
          the lead collection form.
          <br />
          <br />
          The EV savings badge works on all EVs and PHEVs, new or used, and can be customized to your dealership or OEM
          brand guidelines.
        </Typography>

        <StyledLink href="/ev-badge" style={{
      color: '#fff',
      fontWeight: 600,
      padding: '12px 16px 12px 16px',
      textTransform: 'none',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      maxWidth: '180px',
      textDecoration: 'none',
      fontFamily: 'Gilroy',
      borderRadius: '2px'
    }}>
          Learn more
        </StyledLink>
      </>
}, {
  name: 'EV Range Map',
  image: '/assets/images/ev-range-map-2.png',
  block: <>
        <Typography sx={{
      fontWeight: 600,
      fontSize: 20,
      mt: '2rem'
    }}>
          Tackle <span style={{
        color: '#3547C5'
      }}>EV shopper</span> range anxiety from your VDPs
        </Typography>

        <Typography sx={{
      mt: '24px',
      mb: '48px',
      color: '#484E67'
    }}>
          Get rid of range anxiety by providing customers with accurate range data for every new EV and PHEV in your
          inventory.
          <br />
          <br />
          The EV Range Map allows customers to visualize single-charge and round-trip driving distances for your
          electric inventory on a real map.
        </Typography>

        <Link href="/ev-range-map" style={{
      color: '#fff',
      fontWeight: 600,
      backgroundColor: '#3547C5',
      padding: '12px 16px 12px 16px',
      textTransform: 'none',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '180px',
      textDecoration: 'none',
      fontFamily: 'Gilroy',
      borderRadius: '2px'
    }}>
          Learn more
        </Link>
      </>
}, {
  name: 'EV CO₂ Savings Badge',
  image: '/assets/images/co2_hero_2.png',
  block: <>
        <Typography sx={{
      fontWeight: 600,
      fontSize: 20,
      mt: '2rem'
    }}>
          {/* @ts-ignore */}
          Make <span style={{
        color: '#3547C5'
      }}>sustainability</span> a selling point
        </Typography>

        <Typography sx={{
      mt: '24px',
      mb: '48px',
      color: '#484E67'
    }}>
          EV shoppers care about sustainability, but numbers alone can be hard to grasp. The CO₂ Savings Badge
          transforms abstract carbon emissions data into relatable, everyday savings for your customers right from your
          vehicle detail pages (VDPs).
        </Typography>

        <StyledLink href={'/co2'} style={{
      color: '#fff',
      fontWeight: 600,
      padding: '12px 16px 12px 16px',
      textTransform: 'none',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      maxWidth: '180px',
      textDecoration: 'none',
      fontFamily: 'Gilroy',
      borderRadius: '2px'
    }}>
          Learn more
        </StyledLink>
      </>
}];
interface Products {
  items: {
    name: string;
    image: string;
    block: JSX.Element;
  }[];
}
export const ProductTabs: FC<{
  title?: string;
  products?: Products;
}> = ({
  title,
  products = {
    items: productItems
  }
}) => {
  const [activeItem, setActiveItem] = useState(0);
  return <Box sx={{
    maxWidth: ContainerMaxWidth,
    mx: 'auto',
    backgroundColor: '#fff',
    p: {
      xs: MobilePadding,
      md: DesktopPaddingLarger
    }
  }}>
      <Typography sx={{
      fontSize: '38px',
      textAlign: 'center',
      fontWeight: 700,
      lineHeight: {
        xs: 1,
        md: 1.5
      }
    }}>
        {title || 'EV Tools for Forward-thinking Dealerships'}
      </Typography>

      <Box sx={{
      mt: '2rem',
      mb: {
        xs: '2rem',
        md: '4rem'
      }
    }}>
        <Box style={{
        display: 'flex',
        justifyContent: 'center',
        gap: 0
      }}>
          {products?.items?.map((item, index) => {
          const isActive = index === activeItem;
          return <Typography key={index} onClick={() => setActiveItem(index)} sx={{
            cursor: 'pointer',
            p: {
              xs: '6px 16px 6px 16px',
              md: '12px 24px 12px 24px'
            },
            textAlign: 'center',
            fontSize: '18px',
            marginBottom: isActive ? '-2px' : 0,
            borderBottom: isActive ? `4px solid #3547C5` : '1px solid #B9F0D6',
            // backgroundColor: isActive ? Colors.CeruleanBlue : Colors.AliceBlue,
            color: isActive ? '#3547C5' : '#44485A',
            fontWeight: 600
          }}>
                {item.name}
              </Typography>;
        })}
        </Box>
      </Box>

      <Box>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Image src={products.items[activeItem]?.image || ''} width={552} height={360} alt="" />
          </Grid>

          <Grid item xs={12} md={6}>
            {products.items[activeItem]?.block}
          </Grid>
        </Grid>
      </Box>
    </Box>;
};